import { z } from 'zod';
export const StateSummarySchema = z.object({
    stateCode: z.string(),
    recordCount: z.number().int().nonnegative(),
    metrics: z.record(z.union([z.number(), z.string(), z.boolean()])).default({}),
});
export const StatesResponseSchema = z.object({
    mapId: z.string(),
    states: z.array(StateSummarySchema),
});
export const ImportModeSchema = z.enum([
    'insert',
    'update',
    'upsert',
]);
export const ImportStatusSchema = z.enum([
    'pending_upload',
    'validating',
    'preview_ready',
    'committing',
    'committed',
    'cancelled',
    'failed',
]);
export const ImportRowResultSchema = z.object({
    rowNumber: z.number().int().positive(),
    action: z.enum(['insert', 'update', 'unchanged', 'error', 'warning']),
    recordId: z.string().optional(),
    name: z.string().optional(),
    messages: z.array(z.string()).default([]),
});
export const ImportJobSchema = z.object({
    importId: z.string(),
    mapId: z.string(),
    status: ImportStatusSchema,
    mode: ImportModeSchema.default('upsert'),
    fileName: z.string().optional(),
    uploadUrl: z.string().optional(),
    preview: z
        .object({
        inserts: z.number().int().nonnegative(),
        updates: z.number().int().nonnegative(),
        unchanged: z.number().int().nonnegative(),
        errors: z.number().int().nonnegative(),
        warnings: z.number().int().nonnegative(),
        rows: z.array(ImportRowResultSchema),
    })
        .optional(),
    result: z
        .object({
        inserted: z.number().int().nonnegative(),
        updated: z.number().int().nonnegative(),
        skipped: z.number().int().nonnegative(),
        failed: z.number().int().nonnegative(),
    })
        .optional(),
    createdAt: z.string().datetime(),
    createdBy: z.string().email(),
    updatedAt: z.string().datetime(),
    errorMessage: z.string().optional(),
});
export const CreateImportRequestSchema = z.object({
    fileName: z.string().min(1).max(256),
    mode: ImportModeSchema.default('upsert'),
});
export const CreateExportRequestSchema = z.object({
    filters: z.record(z.union([z.string(), z.array(z.string())])).default({}),
    includeArchived: z.boolean().default(false),
});
export const ExportResponseSchema = z.object({
    exportId: z.string(),
    downloadUrl: z.string(),
    expiresAt: z.string().datetime(),
});
export const ListRecordsQuerySchema = z.object({
    state: z.string().optional(),
    status: z.enum(['active', 'archived']).optional(),
    search: z.string().optional(),
    sort: z.string().optional(),
    direction: z.enum(['asc', 'desc']).default('asc'),
    limit: z.coerce.number().int().positive().max(500).default(100),
    cursor: z.string().optional(),
    includeArchived: z
        .union([z.literal('true'), z.literal('false'), z.boolean()])
        .optional()
        .transform((v) => v === true || v === 'true'),
});
export const PaginatedRecordsSchema = z.object({
    items: z.array(z.unknown()),
    nextCursor: z.string().nullable().optional(),
    total: z.number().int().nonnegative().optional(),
});
//# sourceMappingURL=api.js.map